type Props = {
  children: React.ReactNode
  className?: string
  center?: boolean
  useFullHeight?: boolean
  id?: string
}

const FullHeightContainer: React.FC<Props> = ({ children, className = '', center = false, useFullHeight = false, id = '' }) => {
  return (
    <div
      id={id}
      className={`scroll-mt-20 ${useFullHeight ? 'md:min-h-screen' : 'h-fit py-20 md:py-20'} ${center ? 'flex items-center justify-center' : ''} ${className}`}
    >
      <div className="w-full">{children}</div>
    </div>
  )
}

export default FullHeightContainer
